import { inputProps } from "../../interface/inputfieldProps";


export interface SVGProps extends inputProps {
    width: number;
    height: number;
    x: number | string;
    y: number | string;
    node: any;
    setData?: any;
    key: string | number;
    colorHolder: any;
    setColorHolder: any;
}

export interface DragItem {
    id: number | string;
    node: any;
    data: any;
}

export type DimensionType = {
    muliplier: number;
    container?: {
        style?: Record<string, any>;
    };
    containerHeight: number | string;
    orientation: "horizontal" | "vertical";
    graphZoomHeight?: number | string;
    graphZoomWidth?: number | string;
    graphHeight: number | string;
    graphWidth: number | string;
    width: number;
    height: number;
};

export type adjustZoomType = (
    dimension: DimensionType,
    action: boolean,
    initialDimension: DimensionType
) => DimensionType;

export type ActionButtonProps = {
    dimension: DimensionType,
    adjustZoom: adjustZoomType,
    setDimension: React.Dispatch<React.SetStateAction<DimensionType>>,
    zoom: boolean,
    setZoom: React.Dispatch<React.SetStateAction<boolean>>,
    dimensionInitial: DimensionType
 } 
export const ComponentType = {
    component: "component",
};

export interface TreeMapProps extends inputProps {
    width: number;
    height: number;
    margin?: { top: number; right: number; bottom: number; left: number };
    dimension: DimensionType;
    treeData: any;
    setTreeData: any;
  }

export type LinkControlProps = {
    layout: string;
    orientation: string;
    linkType: string;
    
    setOrientation: (orientation: string) => void;
    setLinkType: (linkType: string) => void;
  
  };